<template>
  <ul class="ordered-list">
    <li
      v-for="(text, i) in items"
      :key="i"
      :class="{
        'mt-20': i !== 0,
        'ordered-list__item--lower-latin' : styleTypeLowerLatin
      }"
      class="ordered-list__item ml-20"
    >
      <span
        class="txt--color-03 txt--weight-500 txt--16px txt--height-20px"
        v-html="text"
      />
    </li>
  </ul>
</template>

<script>
export default {
  name: 'OrderedList',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    styleTypeLowerLatin: {
      type: Boolean,
      default: false,
    },
  },
}
</script>

<style lang="scss" scoped>
.ordered-list {
  &__item {
    &--lower-latin {
      list-style-type: lower-latin;
    }

    &::marker {
      background: color('color-03');
    }
  }
}
</style>
